module.exports = __webpack_public_path__ + "img/sbzc_20.2841b7bf.jpg";